
//0000 - 0999 
var CHANGEPASSWD = 100;         //Main Menu
var ORDERLICENSESELECTION = 101;
var ORDERMARKETINGSELECTION = 102;
var ORDERPAYMENTINFO = 103;
var ORDERRECEIPT = 104;
var PRICING = 105;
var ORDERAPPLYDISCOUNT = 106;
var ORDERINVOICE = 107;        
var ADVISORACCOUNTSTATUS = 108;
var ORDERINVOICEINFO = 109;
var SUPPORTCENTER = 110;
var STARTORDERPAGE = 111;
var CLIENTMARKETINGTOOLS = 112;
var ORDERMUSTCALLSALESTOPURCHASE = 113;
var ORDERUPDATECREDITCARD = 114;
var CUSTOMERS = 115;
var RECALCPURCHASE = 117;
var MAINMENU = "";
var RETURNTOCLIENT = 120;
var ORDERADDONLICENSESELECTION = 123;
var RECALCINVOICE = 125;
var RECALCPAYMENT = 126;
var RECALCUPDATECREDITCARD = 127;
var RECALCADDONPURCHASE = 128;
var MAKEAPAYMENT = 129;
var REVIEWREPORTS = 130;
var AUTOREVIEWREPORTS = 140;
var AUTOREVIEWREPORTSEDIT = 141;
var AUTOREVIEWINVESTORS = 145;
var AUTOREVIEWINVESTORSDELETE = 146;
var AUTOREVIEWCREATEREPORT = 150;

//var RECALCOFFICEPAYMENT = 116;
//var RECALCOFFICEPURCHASE = 118;
//var RECALCOFFICEINVOICE = 119;
//var RECALCOFFICEADDONPURCHASE = 124;
//var RECALCOFFICEUPDATECREDITCARD = 128;

var RECALCOFFICEPAYMENT = 151;
var RECALCOFFICEPURCHASE = 152;
var RECALCOFFICEINVOICE = 153;
var RECALCOFFICEADDONPURCHASE = 154;
var OFFICEINVESTORMOVE = 155;
var RECALCOFFICEUPDATECREDITCARD = 156;
var OFFICEMAKEAPAYMENT = 157;
var OFFICEORDERUPDATECREDITCARD = 158;
//var RECALCOFFICEADDONPURCHASE = 159;
var OFFICEUSERS = 160;
var OFFICEUSERREGISTER = 161;
var OFFICEORDERLICENSESELECTION = 170;
//var OFFICEORDERMARKETINGSELECTION = 171;
var OFFICEORDERADDONPAYMENTINFO = 171;
var OFFICEORDERPAYMENTINFO = 172;
var OFFICEORDERRECEIPT = 173;
var OFFICEORDERAPPLYDISCOUNT = 174;
var OFFICEADVISORORDERLICENSESELECTION = 175;
var OFFICEACCOUNTSTATUS = 176;
var OFFICEORDERINVOICEINFO = 177;
var OFFICEORDERINVOICE = 178;
var OFFICEORDERADDONLICENSESELECTION = 179;

var UBSCLIENTSEARCH = 180;

var NAV_ASSETS_INVESTMENT = 400;		//Investment Assets
var ADD_ASSET_INDIVIDUAL = 401;
var RESET_MAXEXTRASAVINGS = 402;
var ADD_ASSET_BY_TOTAL = 403;
var ADD_ASSET_PLANTOTAL = 410;
var EDIT_ASSET_INDIVIDUAL = 451;
var EDIT_ASSET_DETAIL = 452;
var CHANGEASSETDETAILTYPE = 454;
var GOALS_INVESTMENTASSETS_ASSIGN = 470;
var GOALS_INVESTMENTASSETS_AUTOASSIGN = 471;
var DELETE_ASSET = 490;
var DELETE_ASSET_DETAIL = 491;
  
var NAV_ASSETS_OTHER = 500;		//Other Assets
var ADD_OTHERASSET_INDIVIDUAL = 501;
var EDIT_OTHERASSET_INDIVIDUAL = 502;
var DELETE_OTHERASSET = 503;
var GOALS_OTHERASSETS_ASSIGN = 510;
var GOALS_OTHERASSETS_AUTOASSIGN = 511;

var NAV_ASSETS_LIABILITIES = 560;		//Liabilities
var LIABILITY_ADD = 561;
var LIABILITY_EDIT = 562;
var LIABILITY_DELETE = 563; 
var NAV_ASSETS_NETWORTH = 570;			//Networth
var AssetsCurrentPortfolioAllocation = 580;		//Asset Summaries
var AssetsCurrentPortfolioAssetsByTaxCategory = 581;
var AssetsCurrentPortfolioAssetsAssignedByGoal = 582;
var AssetsCurrentPortfolioAssetsByAssetClass = 583;
var AssetsCurrentPortfolioMorningstarAllocationSummary = 584;

var NAV_ASSETS_MODIFIEDASSETCLASSRETURNS = 598;
var NAV_ASSETS_CURRENTALLOCATION = 599;
var GoalsCurrentAllocation = 599;
var ProfileCurrentAllocation = 590;

var NAV_INSURANCE_POLICIES = 600;		//Insurance Policies
var INSURANCE_POLICY_ADD = 601;
var INSURANCE_POLICY_EDIT = 602;
var INSURANCE_POLICY_DELETE = 603;

var NAV_ESTATE_DOCS = 700;

  //Stock Options
var STKOPTS_SUMMARY = 800;
var STKOPTS_SPLIT = 801;
var STKOPTS_PRICESENSITIVITY = 802;
var STKOPTS_FULLVESTINGSCHEDULE = 803;
var STKOPTS_ADDEDITOPTION = 820;
var STKOPTS_DELETEOPTION = 821
var STKOPTS_ADDEDITVESTINGSCHEDULE = 822;
var STKOPTS_ADDEDITGRANT = 823;
var STKOPTS_DELETEGRANT = 824;
var STKOPTS_EXERCISE = 840;
var STKOPTS_EXERCISEDETAILS = 841;
var STKOPTS_EXERCISEGOALASSIGN = 842;
var STKOPTS_EXERCISEGOALASSIGNAUTO = 843;
var STKOPTS_EXERCISEDEFAULTTIMINGS = 844;
var STKOPTS_CASHSCHEDULE = 845;

var RESTRICTEDSTOCK_SUMMARY = 850;
var RESTRICTEDSTOCK_SPLIT = 851;
var RESTRICTEDSTOCK_PRICESENSITIVITY = 852;
var RESTRICTEDSTOCK_FULLVESTINGSCHEDULE = 853;
var RESTRICTEDSTOCK_ADDEDITOPTION = 870;
var RESTRICTEDSTOCK_DELETEOPTION = 871
var RESTRICTEDSTOCK_ADDEDITVESTINGSCHEDULE = 872;
var RESTRICTEDSTOCK_ADDEDITGRANT = 873;
var RESTRICTEDSTOCK_DELETEGRANT = 874;
var RESTRICTEDSTOCK_EXERCISE = 890;
var RESTRICTEDSTOCK_EXERCISEDETAILS = 891;
var RESTRICTEDSTOCK_EXERCISEGOALASSIGN = 892;
var RESTRICTEDSTOCK_EXERCISEGOALASSIGNAUTO = 893;
var RESTRICTEDSTOCK_EXERCISEDEFAULTTIMINGS = 894;
var RESTRICTEDSTOCK_CASHSCHEDULE = 895;

// Custom Portfolios
var CustomPortfolioEdit = 900;
var CustomPortfolioDelete = 901;
var CustomPortfolioChangeBase = 902;
var CustomPortfolioChangeBaseOptimized = 903;
var CustomPortfolioChangeTemplate = 904;

//Efficient Frontier Constraints
var ConstraintsEdit = 951;
var ConstraintGroupEdit = 952;
var ConstraintGroupDelete = 953;

//MorningstarRisk
var MorningstarRiskStart = 1201;
var MorningstarRiskQuestionnaire = 1202;
var MorningstarRiskQuestionnaireSummary = 1203;
var MorningstarRiskQuestionnaireBlank = 1204;
var MorningstarRiskProfileReport = 1205;

//CashEdge
var CashEdgeInstLogins = 1301;
var CashEdgeInstLoginDelete = 1305;
var CashEdgeInstLoginSearch = 1310;
var CashEdgeInstLoginAdd = 1320;
var CashEdgeInstLoginEdit = 1321;
var CashEdgeAccounts = 1330;
var CashEdgeAccountMap = 1340;

  //2000 - 3099 - Financial Planning
var NAV_GOALS_PERSONAL = 2000;
var GOALS_PERSONAL_EDITPARTICIPANT = 2001;
var GOALS_PERSONAL_SAVEPARTICIPANT = 2002;
var GOALS_PERSONAL_DELETEPARTICIPANT = 2003;
var GOALS_TAXOPTIONS = 2010;
  
var NAV_RISKTOLERANCE = 2020;
var GoalsTargetPortfolio = 2021;
var GoalsTargetPortfolioChangeSet = 2022;
var GoalsAdjustedTargetPortfolio = 2023;
var GoalsAdjustedTargetPortfolioChangeSet = 2024;
var NAV_ALLOCATION_RESULTSCOMPARISON = 2030;

var GoalsCustomPortfolioEdit = 2115;
var GoalsCustomPortfolioDelete = 2116;
var GoalsCustomPortfolioChangeBase = 2117;
var GoalsCustomPortfolioChangeBaseOptimized = 2118;

var NAV_RETINCOME = 2200;
var RETINCOME_ADD = 2201;
var RETINCOME_EDIT = 2202;
var RETINCOME_DELETE = 2203;
var RETINCOME_CALC_SOCIALSECURITY = 2220;

var PSEUDOASSET_ADD = 2301;
var PSEUDOASSET_DELETE = 2303;

////var GOALS_INVESTMENTASSETS_ASSIGN = 2300;   ///moved to assets / other assets
////var GOALS_OTHERASSETS_ASSIGN = 2301;
////var GOALS_ASSETS_AUTOASSIGN = 2310;

//var NAV_RISKMANAGEMENT_SUMMARY = 2400;
var NAV_RISKMANAGEMENT_LIFE = 2420;
var NAV_RISKMANAGEMENT_LIFEDEFAULTS = 2421;
var NAV_RISKMANAGEMENT_LIFEDETAILS = 2422;
var NAV_RISKMANAGEMENT_DISABILITY = 2440;
var NAV_RISKMANAGEMENT_DISABILITYDETAILS = 2441;
var NAV_RISKMANAGEMENT_DISABILITYDEFAULTS = 2442;
var NAV_RISKMANAGEMENT_LTC = 2460;
var NAV_RISKMANAGEMENT_LTCCOSTS = 2461;

var Nav = 
{
  Goals : 
  {
    Selection : 2099,
    
    GoalsSelect : 2100,
    AddGoal : 2101,
    EditGoal : 2102,
    DeleteGoal : 2103,
    EditPriority : 2104,
    CurrentSummary : 2105,
    
    EditCollegeOutsideAsset : 2120,
    EditCollegeDetails : 2121,
    CollegeDetailSelectState : 2122,
    CollegeDetailSelectSchool : 2123,
    DeleteCollegeOutsideAsset : 2124,
    DetailedLivingExpenses : 2130,
    ResetExpenseBuckets : 2131,
    BudgetDetails : 2132,
    LifeExpectancy : 2135,
    EditEndExpenseAdjustment : 2133,
    DeleteEndExpenseAdjustment : 2134,
    PlanningAgeCalc : 2140,
  
    Preferences : 2605,
    
    Recommendation: 2611,
    QuickWhatIfLaunch: 2622,
    RetirementFramework: 2612,
    RetirementFrameworkCashFlow: 2613,

    ResultsDetailsCombinedByYear : 2632,
    ResultsCashFlow : 2635,
    ResultsCashFlowChart: 2636,
    WhatIfEditSpendingOrder: 2693,
    WhatIfAddScenario : 2694,
    WhatIfRemoveScenario : 2695,
    WhatIfChangeCalcFamilyAndView : 2696,
    WhatIfEditStressTests : 2697,
    WhatIfMonteCarloTarget : 2698,
    WhatIfResetExpenses : 2692,

    WhatIfSimpleStart : 2688,
    WhatIfSimple: 2689,
    WhatIfSimpleSuperSolve: 2687,

    Presentation : 2800,
    
    ExecutiveSummary : 2890,

    Estate :
    {
      WhatIfGoalDetailsByYear : 3033
    }
  },
  
  CashEdge :
  {
    Summary : 1300,
    UpdateAllAccts : 1301,
    FILoginSearch : 1305,
    FILoginAdd : 1310,
    FILoginEdit : 1311,
    FILoginDelete : 1315,
    FIAccountAdd : 1320,
    FIAccountMapping : 1321,
    FIAccountTransactions : 1322,
    FIAccountDelete : 1325,
    HarvestSts : 1340,
    HarvestAddSts : 1341,
    SiteKeyChallenge : 1342,
    SiteKeyChallengeFailed : 1343,
    CsvAllAccts : 1355,
    CsvOneAcct : 1356

  }
  
};

var NAV_RESULTS_HISTORICAL = 2600;
var NAV_RESULTS_PROJECTED = 2601;
var GOALS_RESULTS_SUMMARY = 2610;
var GOALS_RESULTS_WHATIF = 2620;
var GOALS_RESULTS_QUICKWHATIF = 2622;
var GOALS_RESULTS_INCOMEGRAPH = 2625;
var GOALS_RESULTS_DETAILSCOMBINED = 2630;
var GOALS_RESULTS_DETAILSBYGOAL = 2631;
var GOALS_RESULTS_CHANGEPRIORITY = 2640;
var GOALS_RESULTS_RESTORECURRENT = 2641;
var GOALS_ADVCALCS_START = 2650;
var GOALS_ADVCALCS_SELECTPLAN = 2657;
var GOALS_ADVCALCS_VIEWPORTFOLIOS = 2660;
var GOALS_ADVCALCS_BACKTEST = 2651;
var GOALS_ADVCALCS_VIEWRETURNS = 2658;
var GOALS_ADVCALCS_ROLLINGPERIODS = 2652;
var GOALS_ADVCALCS_ROLLINGPERIODSRESULTS = 2662;
var GOALS_ADVCALCS_EARLYLOSSES = 2653;
var GOALS_ADVCALCS_CONCENTRATEDPOSITION = 2654;
var GOALS_ADVCALCS_CLASSSENSITIVITY = 2655;
var GOALS_ADVCALCS_CLASSSENSITIVITYRESET = 2656;
var GOALS_ADVCALCS_RESULTDETAILS = 2659;
var GOALS_ADVCALCS_VIEWBMCMATRIX = 2665;

var GOALS_RESULTS_SUPERSOLVE = 2680;
var GOALS_RESULTS_SUPERSOLVERESULTS = 2681;

var GOALS_ADVCALCS_MONTECARLO_START = 2670;
var GOALS_ADVCALCS_MONTECARLO_MODELSPLAN1 = 2671;
var GOALS_ADVCALCS_MONTECARLO_MODELSPLAN2 = 2672;
var GOALS_ADVCALCS_MONTECARLO_RESULTS = 2675;
var GOALS_ADVCALCS_MONTECARLO_RESULTS_BRUTEFORCE = 2676;
var GOALS_ADVCALCS_MONTECARLO_VIEWPORTS = 2678;

//var GOALS_RESULTS_WHATIF_ADDRETINCOME = 2680;
//var GOALS_RESULTS_WHATIF_DELETERETINCOME = 2681

////var GOALS_RESULTS_WHATIF_ADDNEWINVESTMENT = 2685;
////var GOALS_RESULTS_WHATIF_DELETENEWINVESTMENT = 2686;
////
var GOALS_RESULTS_WHATIF_SELECTPLANS = 2690;
var GOALS_RESULTS_WHATIF_COPY = 2691;
//var GOALS_RESULTS_WHATIF_PORTFOLIORETURN_COMPARISON = 2692;
var GOALS_RESULTS_WHATIF_DELETEGOAL = 2693;

var GOALS_SRATS_SELECTION = 2700;
var GOALS_SRATS_EDIT_IA = 2701;
var GOALS_SRATS_DELETE_IA = 2702;

var GOALS_PRESENTATION_START = 2800;
var GOALS_PRESENTATION_WELCOME = 2801;
var GOALS_PRESENTATION_WELCOME_STEPS = 2802;
var GOALS_PRESENTATION_ACTIONITEMOPTS = 2805;
var GOALS_PRESENTATION_ACTIONITEMOPT_DELETE = 2806;
var GOALS_PRESENTATION_PREFERENCES = 2810;
var GOALS_PRESENTATION_NETWORTH = 2811;

var GOALS_PRESENTATION_BOTTOMLINE_INTRO1 = 2820;
var GOALS_PRESENTATION_BOTTOMLINE_INTRO2 = 2821;
var GOALS_PRESENTATION_BOTTOMLINE_INTRO3 = 2822;
var GOALS_PRESENTATION_BOTTOMLINE_CURRENT = 2830;
var GOALS_PRESENTATION_BOTTOMLINE_CURRENT_PREFERENCES = 2835;
var GOALS_PRESENTATION_BOTTOMLINE_WHATIF = 2840;
var GOALS_PRESENTATION_BOTTOMLINE_WHATIF_PREFERENCES = 2845;
var GOALS_PRESENTATION_BOTTOMLINE_CONCENTRATEDPOSITIONS = 2846;

var GOALS_PRESENTATION_LOSSCUSHION_SECURITYCHECK = 2850;
var GOALS_PRESENTATION_LOSSCUSHION_LOSSCUSHION = 2853;

var GOALS_PRESENTATION_INSIDENUMBERS_AVGRETURN = 2861;
var GOALS_PRESENTATION_INSIDENUMBERS_BADTIMING = 2864;
var GOALS_PRESENTATION_INSIDENUMBERS_MONTECARLOSINGLE = 2868;
var GOALS_PRESENTATION_INSIDENUMBERS_MONTECARLOALL = 2869;
var GOALS_PRESENTATION_INSIDENUMBERS_RESULTSSUMMARY = 2873;
var GOALS_PRESENTATION_INSIDENUMBERS_RESULTSCHANGEVIEW = 2874;
var GOALS_PRESENTATION_INSIDENUMBERS_RESULTSSUPERSOLVE = 2877;

var GOALS_PRESENTATION_ACTIONITEMS = 2880;

var GOALS_VIEW_INDIVIDUALPORTFOLIODETAIL = 2900;

  //Estate
var ESTATE_START = 3000;
var ESTATE_OPTIONS = 3001;
var ESTATE_ASSET_OWNERSHIP = 3002;
var ESTATE_ASSET_OWNERSHIP_BREAKOUT = 3040;
var ESTATE_TAX_CALC = 3003;
var ESTATE_STRATEGY_SELECT = 3004;
var ESTATE_WHATIF = 3005;

var ESTATE_LIQUIDITY_ANALYSIS = 3010;
var ESTATE_CALC_DETAIL = 3011;
var ESTATE_HEIR_CHARITY_DETAIL = 3012;
var ESTATE_FLOW_CHART = 3013;
var ESTATE_MONTECARLO = 3014;


var ESTATE_STRATEGY_ADD = 3020;
var ESTATE_STRATEGY_EDIT = 3020;
var ESTATE_STRATEGY_DELETE = 3022;
var ESTATE_STRATEGY_MOVE_TO_ILIT = 3023;

var ESTATE_WHATIF_CHANGE_SCENARIO = 3030;
var ESTATE_WHATIF_CALC = 3031;
var ESTATE_WHATIF_GOALDETAILS = 3032;

  //3100 - 3999 - Asset Allocation
var AssetAllocationStart = 3100;
var AssetAllocationRiskTolerance = 3110;
var AssetAllocationRiskToleranceNoRiskScore = 3111;
var AssetAllocationSelectInvestmentAssets = 3200;
var AssetAllocationAddInvestmentAsset = 3201;
var AssetAllocationEditInvestmentAsset = 3202;
var AssetAllocationEditInvestmentAssetDetail = 3203;
var AssetAllocationDeleteInvestmentAsset = 3204;
var AssetAllocationDeleteInvestmentAssetDetail = 3205;

var AssetAllocationTargetReturn = 3310;
var AssetAllocationTargetPortfolio = 3320;
var AssetAllocationTargetPortfolioShowDetails = 3321;
var AssetAllocationTargetPortfolioChangeSet = 3322;
var AssetAllocationResultsComparison = 3400;
var ALLOC_PORTFOLIOSHOWPRODUCTSBYASSETCLASS = 3401;
var AssetAllocationMonteCarlo = 3500;
var AssetAllocationMonteCarloDetails = 3501;

  //3502 - 3520	- Reallocation
var ImplSellSelect = 3502;
var ImplSellProductFinder = 3503;
var ImplSellEdit = 3504;
var ImplSellDelete = 3505;
var ImplBuySelect = 3507;
var ImplBuyProductFinder = 3508;
var ImplBuyEdit = 3509;
var ImplBuyDelete = 3510;
var ImplBuySolutionAdd = 3511;
var ImplBuySolutionEdit = 3512;
var ImplBuyEditManualAccount = 3513;
var ImplBuyRebalanceSelect = 3516;
var ImplBuyRebalanceAdd = 3517;
var ImplBuyEditRebalance = 3518;
var ImplRebalanceAccountDelete = 3519;
var ImplBuyEditRebalanceTrading = 3520;
var ImplBuySolutionSelectAdvisorProducts = 3525;
var ImplBuySolutionAddEditAdvisorProducts = 3526;
var ImplBuySolutionDeleteAdvisorProducts = 3527;
var ImplActionPlan = 3530;
var ImplExport = 3531;

  //4000 - 4999 - Lifetime Income
var LIFETIMEINCOME_START = 4001;
var LIFETIMEINCOME_SELECTGOALPLANINVASSETS = 4011;
var LIFETIMEINCOME_TARGETPORTFOLIO = 4031;
var LIFETIMEINCOME_PORTFOLIODETAILS = 4041;
var LIFETIMEINCOME_RESULTS = 4061;
var LIFETIMEINCOME_RESULTS_DETAILS = 4071;

  //5000 - 5499 _ Misc
var INVESTORPROFILE_PERSONAL = 5000;			//Profile
var INVESTORPROFILE_PERSONAL_EDITPARTICIPANT = 5001;
var INVESTORPROFILE_PERSONAL_SAVEPARTICIPANT = 5002;
var INVESTORPROFILE_PERSONAL_DELETEPARTICIPANT = 5003;
var INVESTORPROFILE_PERSONAL_VERIFYCONVERTTOSINGLE = 5004;
var ADVISORPROFILE_UPDATE = 5010;			//Advisor Profile

var PORTFOLIO_DETAIL = 5050;      //Portfolio Detail
var ADJ_PORTFOLIO_DETAIL = 5051;      //Adjusted Portfolio Detail

//Plans
var PlanSelect = 5109;
var PlansCreate = 5110;
var PlansEdit = 5111;
var PlansCopy = 5112;
var PlansChangeStatus = 5113;
var ResetAutoReviewUbs = 5114;

var HasAccountsToRefresh = 5120;
var PlansRefreshAccounts = 5122;
var PlansMapAccounts = 5124;

var GuestSharing = 5102;
var GuestSharingEditGuest = 5103;
var GuestSharingUsage = 5105;
var GuestSharingEditPlan = 5106;
var GuestSharingSelectTargetPage = 5107;
var GuestSharingResetLockout = 5108;

var ManageIntegrationPartners = 5128;
var ManageIntegrationPartnersSearch = 5129;
var ManageIntegrationBlackDiamondListAccounts = 5133;
var ManageIntegrationBridgePortfolioListAccounts = 5134;
var ManageIntegrationImportsExcluded = 5131;
var DeleteIntegrationImportExcluded = 5132;
var ManageIntegrationLoringWardSearch = 5135;
var ManageIntegrationLoringWardLink = 5136;
var ManageIntegrationPershingListAccounts = 5137;
var ManageIntegrationAssetBookListAccounts = 5138;
var ManageIntegrationAlbridgeListAccounts = 5139;
var ManageIntegrationRedtailListHouseholds = 5140;
var ManageIntegrationLoringwardListHouseholds = 5141;
var ManageIntegrationLoringwardMapHouseholds = 5142;
var ManageIntegrationOppenheimerListAccounts = 5143;
var ManageIntegrationTDAmeritradeVeoListAccounts = 5144;
var ManageIntegrationScottradeListAccounts = 5198;
var ManageIntegrationAdvisorExchange = 5147;
var ManageIntegrationPanoramixListClients = 5146;
var ManageIntegrationCashEdgeMssbListAccounts = 5199;

var MGSUpdateFeeInfo = 5145;

  //5200 - 5399 Clients
var CLIENTS_CLIENTSELECTION = 5200;			
var CLIENTS_SEARCHNAME = 5201;			
var CLIENTS_SEARCHSNN = 5202;			
var CLIENTS_CREATECLIENT = 5204;
var CLIENTS_DELETECLIENT = 5205;
var CLIENTS_COPYCLIENT = 5206;
var CLIENTS_REACTIVATECLIENT = 5207;
var CLIENTS_LOADEXAMPLES = 5250;
var CLIENTS_EDITCLIENT = 5270;

var CLIENTS_REFRESHASSET_PLEASEWAIT = 5220;

var CLIENTS_ADVISORSSHAREDWITHME = 5271;
var CLIENTS_SHAREWITHBROKER = 5272;
var CLIENTS_EDITADVISORSHARING = 5273;
var CLIENTS_BROKER_MYCLIENTS = 5280;
var CLIENTS_ADVISORSHARING_GRANTACCESS = 5274;
var CLIENTS_ADVISORSHARING_DENYACCESS = 5275;
var CLIENTS_IMPERSONATESTART = 5276;
var CLIENTS_IMPERSONATEEND = 5277;

//Partners
var CLIENTS_ADVENTEDITACCOUNTS = 5300;
var CLIENTS_ADVENTADDACCOUNT = 5301;
var CLIENTS_ADVENTDELETEACCOUNT = 5302;
var CLIENTS_ALBRIDGESEARCH = 5310;
var CLIENTS_ALBRIDGECREATECLIENT = 5311;
var CLIENTS_HORIZONSSEARCH = 5312;
var CLIENTS_HORIZONSCREATECLIENT = 5314;
var CLIENTS_REDTAILSEARCH = 5315;
var CLIENTS_REDTAILCREATECLIENT = 5316;
var CLIENTS_UBSLINKCLIENT = 5305;
var CLIENTS_LORINGWARDSEARCH = 5320;
var CLIENTS_LORINGWARDCREATE = 5321;

var ReportsBasic = 5500;
var ReportsEditCustomReportSections = 5501;
var ReportsEditCustomReportOptions = 5502;
var ReportsDeleteCustomReport = 5503;
var ReportsChangePrintOptions = 5505;
var ReportsPrintSelectedReportSection = 5506;
var ReportsDisplay = 5510;
var ReportsDisplayReturnFrame = 5511;
var ReportsReturnToPlan = 5515;
var ReportsHistory = 5520;
var ReportsHistoryDeleteSavedReport = 5522;
var ReportsDeliveryAndReview = 5530;
var ReportsDeliveryAndReviewSaveChanges = 5531;
var ReportsCreateIPS = 5540;
var ReportsCreateLWAnalysis = 5541;
var ReportsCreateGapAnalysis = 5542;
var ReportsWaaApproval = 5550
var ReportsBasicProfile = 5560;

//ING Proposal
var Proposal_Start = 6001;
var Proposal_RiskTolerance = 6011;

//Chase Proposal
var ChaseProposal_Start = 6200;
var ChaseProposal_LeaveStartPage = 6201;
var ChaseProposal_RiskTolerance = 6210;
var ChaseProposal_ImplementationBuySelect = 6220;
var ChaseProposal_ImplementationBuyDelete = 6221;
var ChaseProposal_ImplementationBuyEdit = 6222;
var ChaseProposal_ProposedModel = 6230;
var ChaseProposal_ResultComparison = 6231;
var ChaseProposal_MonteCarloSummary = 6232;
var ChaseProposal_MonteCarloDetails = 6233;
var ChaseProposal_CombinedView = 6234;


//Plan Monitoring
var PlanMonitoringAdopt = 6500;
var PlanMonitoringAdoptWebRequestXml = 6502;
var PlanMonitoringAdoptPopup = 6505;
var PlanMonitoringStarTrackHistory = 6510;
var PlanMonitoringNetWorthHistory = 6520;
var PlanMonitoringHideJournalEntry = 6525;
var PlanMonitoringGoalHistory = 6530;

  //7000 - 7599 - Card Game
var CARDGAME_INTRO = 7100;
var CARDGAME_INTRO1 = 7200;
var CARDGAME_PICKTABLE1 = 7201;
var CARDGAME_GAME1 = 7202;
var CARDGAME_MONTECARLO1 = 7203;
var CARDGAME_WHATITMEANS1 = 7204;
var CARDGAME_INTRO2 = 7300;
var CARDGAME_PICKTABLE2 = 7301;
var CARDGAME_GAME2 = 7302;
var CARDGAME_MONTECARLO2 = 7303;
var CARDGAME_WHATITMEANS2 = 7304;
var CARDGAME_INTRO3 = 7400;
var CARDGAME_PICKTABLE3 = 7401;
var CARDGAME_COMPARE3 = 7402;
var CARDGAME_MONTECARLO3 = 7403;
var CARDGAME_WHATITMEANS3 = 7404;
var CARDGAME_NOWWHAT = 7500;

var BUDGET_START = 8000;
var BUDGET_WORKSHEET = 8010;
var BUDGET_WS_CHG_BUDGETS = 8011;
var BUDGET_WS_COPY_BUDGET = 8012;
var BUDGET_WS_ADD_CATEGORY = 8013;
var BUDGET_WS_DEL_CATEGORY = 8014;
var BUDGET_WS_ADD_TRANSACTION = 8016;
var BUDGET_WS_DEL_TRANSACTION = 8017;
var BUDGET_REPORTS = 8020;
var BUDGET_REPORTDISPLAY = 8025;

if (!Nav) Nav = {};

Nav.GuaranteedIncome =
{
  Start : 9001,
  Expense : 9002,
  Income : 9003,
  Results: 9010,
  Details : 9011,
  Budget : 9013,
  BudgetAddCategory : 9014,
  BudgetDeleteCategory : 9015,
  EditEndExpenseAdjustment : 9020,
  DeleteEndExpenseAdjustment : 9021,
  TaxOptions : 9030,
  SocialSecurity: 9040,
  CalculateSocialSecurity: 9041,
  SocialSecurityStrategy: 9042,
  Reports : ReportsBasic,
  ReportsHistory : ReportsHistory
};

  //11000 - 16999 - Settings
var Settings_Type_Advisor = 1;
var Settings_Type_Role = 2;
var Settings_Type_Inst = 3;
var Settings_Type_System = 4;

var Settings_Login = 10000;
var Settings_Menu = 10001;
var Settings_Menu_SearchReferrals = 10002;
var Settings_Menu_SearchRoles = 10003;
var Settings_Menu_SearchAdvisors = 10004;
var Settings_Menu_SearchMoveInvestors = 10005;
var Settings_SystemSettings = 10010;
var Settings_InstOptions = 10011;
var Settings_ReferralOptions = 10012;
var Settings_AdvisorProfile = 10013;
var Settings_AdvisorAccess = 10014;
var Settings_OfficeOptions = 10017;
var Settings_SystemOptions = 10020;
var Settings_CustomLogoUpload = 10021;
var Settings_PartnerOptions = 10030;
var Settings_IntegrationLogin = 10031;
var Settings_DisplayRecordset = 10032;


var Settings_GoalBasicOptions = 10040;
var Settings_WhatIfScenarioDefaults = 10041;
var Settings_WhatIfCalcDefaults = 10044;
var Settings_WhatIfVisibilityOptions = 10048;
var Settings_PresentationOptions = 10050;
var Settings_FinPlanMonitoringOptions = 10052;
var Settings_FinPlanSpendingOrder = 10053;
var Settings_EditFinPlanSpendingOrder = 10054;

var Settings_AssetAllocationOptions = 10055;
var Settings_GuaranteedIncomeOptions = 10056;

var Settings_ImplOptions = 10060;
var Settings_ImplProductCategories = 10061;
var Settings_ImplProductEditCategories = 10062;
var Settings_ImplProductOrderByCategories = 10063;
var Settings_ImplProductDeleteCategories = 10064;
var Settings_ImplProductDeleteCategoryVerify = 10065;
var Settings_ImplProducts = 10070;
var Settings_ImplProductsEdit = 10071;
var Settings_ImplProductsDelete = 10072;
var Settings_ImplSolutionOptions = 10080;
var Settings_ImplSolutions = 10081;
var Settings_ImplSolutionEdit = 10082;
var Settings_ImplSolutionsOrderBy = 10083;
var Settings_ImplSolutionDelete = 10084;
var Settings_ImplSolutionDeleteVerify = 10085;
var Settings_ImplSolutionsProducts = 10090;
var Settings_ImplSolutionProductsDefaultEdit = 10091;
var Settings_ImplSolutionProductsEdit = 10092;  
var Settings_ImplSolutionProductDelete = 10093;

var Settings_ImplSolutionTargetAllocationDefaultEdit = 10094;
var Settings_ImplSolutionEnterByHoldingDefaultEdit = 10095;

var Settings_LifetimeIncomeOptions = 10100;
var Settings_CollaborationOptions = 10110;
var Settings_BrokerVersionOptions = 10120;
var Settings_ReportOptions = 10130;
var Settings_ReportsEditSections = 10131;
var Settings_ReportsEditOptions = 10132;
var Settings_ReportsDeleteReport = 10133;
var Settings_ReportsEditSortOrder = 10135;
var Settings_ReportsRequiredSections = 10140;
var Settings_ReportsEditRequiredSections = 10141;
var Settings_MStarOverrides = 10150;
var Settings_MStarOverridesCreateVerify = 10151;
var Settings_MStarOverrideEdit = 10152;
var Settings_MStarOverrideDelete = 10153;

var Settings_MonteCarloTargetOverrides = 10155;
var Settings_MonteCarloTargetOverridesCreateVerify = 10156;
var Settings_MonteCarloTargetOverrideEdit = 10157;
var Settings_MonteCarloTargetOverrideDelete = 10158;

var Settings_SignOnAndRegisterOptions = 10160;
var Settings_SignOnConfigEdit = 10161;
//var Settings_SignOnGenerateCryptKey = 10162;
//var Settings_SignOnGenerateWebSvcCryptKey = 10163;

var Settings_GoalCardsOverrides = 10165;
var Settings_GoalCardsOverridesCreateVerify = 10166;
var Settings_GoalCardsOverrideEdit = 10167;
var Settings_GoalCardsOverrideDelete = 10168;

var Settings_ReturnOptions = 10200;
var Settings_ReturnOptionsEdit = 10201;
var Settings_ReturnOptionsVerifyUpdate = 10202;
var Settings_StartCreatePortfolios = 10210;
var Settings_VerifyCreatePortfolios = 10211;
var Settings_MapPortfolios = 10212;
var Settings_MapPortfoliosSchedule = 10213;
var Settings_MapPortfoliosInstSummary = 10214;
var Settings_PortfoliosSummary = 10220;
var Settings_Inflation = 10230;
var Settings_InflationEdit = 10231;
var Settings_InflationVerifyUpdate = 10232;
var Settings_AssetClassGroups = 10240;
var Settings_AssetClassGroupEdit = 10241;
var Settings_AssetClassGroupOrderEdit = 10242;
var Settings_AssetClassGroupVerifyDelete = 10243;
var Settings_AssetClasses = 10250;
var Settings_AssetClassEdit = 10251;
var Settings_AssetClassOrderEdit = 10252;
var Settings_InstrumentOrderSummary = 10253;
var Settings_AssetClassesMoveAndDelete = 10260;
var Settings_AssetClassVerifyDelete = 10261;
var Settings_AssetClassVerifyMove = 10262;
var Settings_AssetClassKeysEdit = 10263;
var Settings_Annuities = 10264;
var Settings_AnnuityPayouts = 10265;
var Settings_Correlations = 10270;
var Settings_CorrelationsEdit = 10271;
var Settings_CorrelationsCalcHist = 10272;
var Settings_Constraints = 10280; 
var Settings_ConstraintsEdit = 10281; 
var Settings_ConstraintGroupEdit = 10282; 
var Settings_ConstraintGroupDelete = 10283;
var Settings_MStarMappings = 10290;
var Settings_MStarMappingEdit = 10291;
var Settings_MStarBenchmarks = 10295;
var Settings_MStarBenchmarkEdit = 10296;
var Settings_PortfolioSets = 10300;
var Settings_PortfolioSetEdit = 10301;
var Settings_PortfolioSetOrderEdit = 10302;
var Settings_PortfolioSetsDelete = 10310;
var Settings_PortfolioSetVerifyDelete = 10311;
var Settings_Portfolios = 10320;
var Settings_PortfolioEdit = 10321;
var Settings_PortfolioOrderEdit = 10322;
var Settings_PortfoliosMoveAndDelete = 10330;
var Settings_PortfolioVerifyDelete = 10331;
var Settings_PortfolioVerifyMove = 10332;
var Settings_HistoricalPeriod = 10340;
var Settings_HistoricalPeriodEdit = 10341;
var Settings_HistoricalPeriodVerifyUpdate = 10342;				
var Settings_UpdateAnnualReturnsVerify = 10350;
var Settings_RiskScoring = 10360;
var Settings_RiskScoringEdit = 10361;
var Settings_PermissionTemplates = 10500;
var Settings_SharingUsage = 10510;
var Settings_SettingsUsers = 10600;
var Settings_SettingsUserEdit = 10601;
var Settings_SettingsUserEditPassword = 10602;
var Settings_MoveInvestors = 10701;
var Settings_CreateRole = 10810; 

var Stats_TotalUsage = 50000;
var Stats_AdvisorUsage = 50001;
var Stats_InvestorDataByAdvisor = 50002;
var Stats_MgsReports = 50003;
var Stats_CashEdge = 50005;
var Stats_MorningstarRisk = 50006;
var Stats_EZEnterprise = 50007;
var Stats_VoyaProposalTotalUsage = 50010;
var Stats_VoyaProposalDetailUsage = 50011;
var Stats_UbsAutoReview = 50012;

var Stats_Logout = 50013;

function submit_form(frm)
{
  frm.submit(frm);
}

function addListeners()
{
  PIE.FormReset = jQuery('#frmMG').serialize();
}

function canUpdateThisPage () {
var frm = document.frmMG;

var lCanUpdateThisPage = true;

    if (frm.CanUpdateThisPage) {
        lCanUpdateThisPage = convertToBool(frm.CanUpdateThisPage.value);
    }

    return lCanUpdateThisPage;
}	

function saveUserChanges(plDestPage) {
var lbContinue;

    lbContinue = true;

    if (canUpdateThisPage()) {
        if (window.fpValidateData) {
            lbContinue = window.fpValidateData();
        }
    }
    
    if (lbContinue) {
        document.frmMG.sDestPage.value = plDestPage;
        document.frmMG.bStorePage.value = true;
        submit_form(document.frmMG);
    }

    return lbContinue;
}

function saveUserChangesAndCloseWindow(plDestPage) {
    var lbContinue;

    lbContinue = true;

    if (canUpdateThisPage()) {
        if (window.fpValidateData) {
            lbContinue = window.fpValidateData();
        }
    }

    if (lbContinue) {
        var frm = document.frmMG;

        frm.sDestPage.value = plDestPage;
        frm.bStorePage.value = true;

        $.ajax({
            type: "POST",
            url: frm.getAttribute('action'),
            data: $(frm).serialize(),
            error: function (xhr, status, error) {
                alert('An erorr occurred while saving the report template.');
            },
            success: function (response) {
                window.close();
            }
        });
    }
    return lbContinue;
}


function convertToBool (pExpr) {
var lValue = false;

    if (pExpr != null) 
	{
	    var lExprString = pExpr.toString();

	    if (lExprString.length > 0)
		{
		    switch (lExprString.toUpperCase())
			{
				case "TRUE" : 
				case "Y" : 
				case "YES" : 
				case "ON":
					lValue = true;
					break;

				default:
				    var lExprValue = parseInt(0 + pExpr);
            		
					lValue = (lExprValue != 0);
					break;
			}
		}
	}
	
	return lValue;
}

function cancelUserChanges(plDestPage, psMsg) {
var frm = document.frmMG;
var lContinue = true;

    if (canUpdateThisPage()) {
        if (psMsg)
            lContinue = confirm(psMsg);           
	    else
	        lContinue = confirm('Are you sure you want to lose your changes?');
	}

  if (lContinue) {
    document.frmMG.sDestPage.value = plDestPage;
    document.frmMG.bStorePage.value = false;
    submit_form(document.frmMG);
  }
  else {
    if (typeof (Shared) !== 'undefined') {
      Shared.Navigate.LoadingStop();
    } else {
      Mgp.Navigate.LoadingStop();
    }
  }
}

function isSinglePageConversationLegacyIframe() {
  //Do this check in a try catch because if the window parent is cross-domain this will throw an error
  try {
    if (window.parent.document.getElementById('mg-conversation-legacy-step-iframe')) {
      return true;
    }
  } catch (e) {
    return false;
  }
}

function navigateTo(plDestPage, plReturnPeriodID) {
var lbSave = true;
var lbContinue = true;
var frm = document.frmMG;

	if ((window.bDoNotSaveOnNavigateTo) && (window.bDoNotSaveOnNavigateTo == true))
		lbSave = false;

  if (lbSave) {
    if (window.fpValidateData) {
      lbContinue = window.fpValidateData();
    }
    //Used in Legacy Settings for XSS preventation validation 
    if (window.fpValidateData2) {
      lbContinue = lbContinue && window.fpValidateData2();
    }
  }

	if (lbContinue) 
	{
		if(plReturnPeriodID != null)
			frm.lReturnPeriodID.value = plReturnPeriodID;

		if (frm) {
		  frm.sDestPage.value = plDestPage;
      frm.bStorePage.value = lbSave;

      //Only Used for the Single Page Conversation version for Reports step
      if (isSinglePageConversationLegacyIframe()) {
        frm.target = '_parent';
      }
     
      submit_form(frm);
		}
		else {
		  submit_form(document.forms[0]);  //HACK for Add Holding page in Investment Assets
		}
	}
	return lbContinue;	
}

function moveNextPage() {
	navigateTo(document.frmMG.sNextPage.value);
}

function movePreviousPage() {
	navigateTo(document.frmMG.sPreviousPage.value);
}

function MoveToDataPage(pDataPage) {
var frm = document.frmMG;
var lNextPage = 0;
  lNextPage = (frm.CurrentDataPage.value * 1);
  lNextPage += (pDataPage - 0);
  frm.CurrentDataPage.value = lNextPage;
  frm.sDestPage.value = frm.sSrcPage.value;
	submit_form(frm);
}

function changeFormForMVC() {
  //Need to change form element names so MVC can properly bind to the edit model 
  var elements = document.frmMG.elements;
  for (var i = 0; i < elements.length; i++) {
    var element = elements[i];
    if (element.hasAttribute('id') && element.hasAttribute('name')) {
      element.name = element.id.replace(/_/gi, ".");;
    }
  }
}